import {
  GET_EVENTS,
  GET_EVENTS_FAIL,
  GET_EVENTS_SUCCESS,
  ADD_NEW_EVENT,
  ADD_EVENT_SUCCESS,
  ADD_EVENT_FAIL,
  UPDATE_EVENT,
  UPDATE_EVENT_SUCCESS,
  UPDATE_EVENT_FAIL,
  DELETE_EVENT,
  DELETE_EVENT_SUCCESS,
  DELETE_EVENT_FAIL,
  DELETE_MONTH_EVENTS,
  DELETE_MONTH_EVENTS_SUCCESS,
  DELETE_MONTH_EVENTS_FAIL,
  GET_CATEGORIES,
  GET_CATEGORIES_SUCCESS,
  GET_CATEGORIES_FAIL,
  PROFILE_ERROR, PROFILE_SUCCESS, UPDATE_PROFILE, GET_PROFILE_SUCCESS, GET_PROFILE_ERROR, GET_PROFILE } from "./actionTypes"

export const getEvents = () => ({
  type: GET_EVENTS,
})

export const getEventsSuccess = events => ({
  type: GET_EVENTS_SUCCESS,
  payload: events,
})

export const getEventsFail = error => ({
  type: GET_EVENTS_FAIL,
  payload: error,
})

export const addNewEvent = event => {
  return {
     type: ADD_NEW_EVENT,
     payload: event,
  }
}

export const addEventSuccess = event => ({
  type: ADD_EVENT_SUCCESS,
  payload: event,
})

export const addEventFail = error => ({
  type: ADD_EVENT_FAIL,
  payload: error,
})

export const updateEvent = event => ({
  type: UPDATE_EVENT,
  payload: event,
})

export const updateEventSuccess = event => ({
  type: UPDATE_EVENT_SUCCESS,
  payload: event,
})

export const updateEventFail = error => ({
  type: UPDATE_EVENT_FAIL,
  payload: error,
})

export const deleteEvent = eventId => ({
  type: DELETE_EVENT,
  payload: eventId,
})

export const deleteEventSuccess = eventId => ({
  type: DELETE_EVENT_SUCCESS,
  payload: eventId,
})

export const deleteEventFail = error => ({
  type: DELETE_EVENT_FAIL,
  payload: error,
})

export const deleteMonthEvents = events => ({
  type: DELETE_MONTH_EVENTS,
  payload: events,
})

export const deleteMonthEventsSuccess = events => ({
  type: DELETE_MONTH_EVENTS_SUCCESS,
  payload: events,
})

export const deleteMonthEventsFail = error => ({
  type: DELETE_MONTH_EVENTS_FAIL,
  payload: error,
})

export const getCategories = () => ({
  type: GET_CATEGORIES,
})

export const getCategoriesSuccess = categories => ({
  type: GET_CATEGORIES_SUCCESS,
  payload: categories,
})

export const getCategoriesFail = error => ({
  type: GET_CATEGORIES_FAIL,
  payload: error,
})

export const updateProfile = user => {
  return {
    type: UPDATE_PROFILE,
    payload: { user },
  }
}

